export const TRACK_PAYMENT_REQ = 'TRACK_PAYMENT_REQ';
export const TRACK_PAYMENT_ERR = 'TRACK_PAYMENT_ERR';
export const TRACK_PAYMENT_OK = 'TRACK_PAYMENT_OK';
export const TRACK_USER_ACTION_REQ = 'TRACK_USER_ACTION_REQ';
export const TRACK_PLAN_ACTION_REQ = 'TRACK_PLAN_ACTION_REQ';

